import React from 'react';

export interface UserBlocked {

}

export const UserBlocked = () => {
    return (
        <div className={'user-item__blocked'}>
            Blocked
        </div>
    )
}
